import React, { useState } from "react";
import Title from "../../ui/Title/Title";
import styles from "./AddUsersContainer.module.scss";
import Button from "../../ui/Button/Button";
import { Modal } from "../../ui/Modal/Modal";
import { RegistrationUserModule } from "../../modules";
import { useDispatch, useSelector } from "react-redux";
import { Pencil2Icon, TrashIcon } from "@radix-ui/react-icons";
import {
  setEditEmployeeData,
  setIsUpdateEmployees,
} from "../../store/slices/employeesSlice";
import { deleteEmployee } from "../../utils/api/actions/user";

export const AddUsersContainer = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state?.user?.data);
  const { employees = [], isUpdateEmployees } = useSelector(
    (state) => state?.employees
  );

  const [isUserAdd, setIsUserAdd] = useState(false);

  const handleOpenAddUserModal = () => setIsUserAdd(true);

  const handleCloseAddUserModal = () => {
    setIsUserAdd(false);
    if (isUpdateEmployees) {
      dispatch(setIsUpdateEmployees(false));
    }
  };

  const handleEdit = (employee) => {
    dispatch(setIsUpdateEmployees(true));
    dispatch(setEditEmployeeData(employee));
  };

  const handleDelete = (employeeId) => {
    dispatch(deleteEmployee(user.id, employeeId));
  };

  const getEmployeeName = ({ surname, firstName, patronymic }) =>
    `${surname} ${firstName} ${patronymic}`;

  console.log(isUserAdd, isUpdateEmployees);

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <Title className={styles.title} title="Сотрудники" />
        <Button
          title="Добавить"
          titleClassName={styles.buttonTitle}
          className={styles.button}
          onClick={handleOpenAddUserModal}
        />
      </div>

      <table className={styles.usersTable}>
        <thead>
          <tr>
            <th>ФИО</th>
            <th>Почта</th>
            <th>Телефон</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {employees.length > 0 ? (
            employees.map((employee) => (
              <tr key={employee.id}>
                <td>{getEmployeeName(employee)}</td>
                <td>{employee?.email}</td>
                <td>{employee?.phone}</td>
                <td className={styles.actions}>
                  <Pencil2Icon
                    className={styles.iconPencil}
                    onClick={() => handleEdit(employee)}
                    cursor="pointer"
                  />
                  <TrashIcon
                    className={styles.iconTrash}
                    onClick={() => handleDelete(employee.id)}
                    cursor="pointer"
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={4} className={styles.noUsers}>
                У вас нет добавленных сотрудников
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Modal
        visible={isUserAdd || isUpdateEmployees}
        handleClose={handleCloseAddUserModal}
      >
        <RegistrationUserModule setIsUserAdd={setIsUserAdd} />
      </Modal>
    </div>
  );
};
